/* Fast Simon storefront hooks (grid, filters, swatches, upsell, notify-me,
 * quick view, JSON-LD). Moved out of snippets/FSHooks.liquid so the ~54 KB
 * is a cached asset rather than being re-sent inline in the head of every
 * page. It is still loaded synchronously in the head so it registers its
 * hooks before Fast Simon's app block runs, as the inline version did. The
 * one thing Fast Simon must see before it initialises, __fast_options, stays
 * inline in the snippet. No Liquid in here by design.
 */
/* Everything below runs inside one closure. This is a classic script, so a
   top-level function or var would otherwise become a window property, and
   third party embeds read window for their own conventions: the booking
   app calls window.variantId.split(), so a helper of ours by that name
   crashed it and no Select a time button was drawn. The only global this
   file sets on purpose is window.SwymBackInStockConfig, assigned explicitly. */
(function () {
    /* ============================================================================
       CONFIGURATION
       ============================================================================ */

    /* ============================================================================
       UTILITY FUNCTIONS
       ============================================================================ */
    
    /**
     * Get all product card elements from the Fast Simon grid
     */
    function getProductElements(element) {
        return [...element.querySelectorAll('.fs-results-product-card')];
    }

    /**
     * Get nested property from object using dot notation
     */
    function getNestedProperty(obj, path) {
        return path.split('.').reduce((current, prop) => current?.[prop], obj);
    }

    /**
     * Remove parentheses from review count text
     */
function formatReviewsCount(productElement) {
  return;
}

    /**
     * Initialize SWYM library with timeout
     */
    function initializeSwym() {
        if (typeof window._swat !== 'undefined') {
            return Promise.resolve(window._swat);
        }
        
        return new Promise((resolve) => {
            let attempts = 0;
            const maxAttempts = 100; // 10 seconds
            
            const checkSwym = setInterval(() => {
                attempts++;
                if (typeof window._swat !== 'undefined') {
                    clearInterval(checkSwym);
                    console.log('[SWYM] Initialized successfully');
                    resolve(window._swat);
                } else if (attempts >= maxAttempts) {
                    clearInterval(checkSwym);
                    console.warn('[SWYM] Library not loaded after 10 seconds');
                    resolve(null);
                }
            }, 100);
        });
    }

    /* ============================================================================
       PRODUCT AVAILABILITY
       ============================================================================ */

    window.SwymBackInStockConfig = {
        productDataMapping: {
            id: 'id',
            variantId: 'vra.0.v_id',
            title: 'title',
            url: 'productURL',
            image: 'imageURL',
            price: 'price',
            currency: 'currency',
            available: 'isSoldOut'
        },
        
        checkAvailability: (productData) => {
            if (productData.isSoldOut === true) return false;
            return !everyVariantUnsellable(productData.vra);
        }
    };

    /* ------------------------------------------------------------------
       Reading FastSimon's variant tuples.

       A vra entry is a tuple, not an object:
         [46699421565163, [["Colour", ["#101 Joyful"]], ["Sellable", [true]],
                           ["Price", ["GBP:14.00"]], ...]]
       so variant.sellable is undefined on every entry ever returned, and
       `variant.sellable === false` is false for all input. The two callers
       below have therefore never refined anything: the variant branch of
       isProductOutOfStock always returned false and checkAvailability's
       always returned true. Reading the tuple is what those comments meant.
       ------------------------------------------------------------------ */
    /* Two shapes reach this file. The ssr-grid endpoint returns tuples,
       [id, [["Colour",["#101 Joyful"]], ["Sellable",[true]], ...]], while the
       SDK hands the serp-product-grid hook objects with lowercase keys,
       {v_id: 4714..., sellable: true, price: "GBP:37.4", size: "500ml", ...}.
       Everything below reads through these two so callers never care which. */
    function variantAttributes(variant) {
        if (Array.isArray(variant)) return Array.isArray(variant[1]) ? variant[1] : [];
        if (variant && typeof variant === 'object') {
            return Object.keys(variant).map(function (k) { return [k, variant[k]]; });
        }
        return [];
    }

    function variantId(variant) {
        if (Array.isArray(variant)) return variant[0];
        if (variant && typeof variant === 'object') {
            return variant.v_id != null ? variant.v_id : (variant.variant_id != null ? variant.variant_id : variant.id);
        }
        return null;
    }

    function variantAttribute(variant, key) {
        var wanted = String(key).toLowerCase();
        var pairs = variantAttributes(variant);
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i];
            if (!Array.isArray(pair)) continue;
            if (String(pair[0]).toLowerCase() !== wanted) continue;
            return Array.isArray(pair[1]) ? pair[1][0] : pair[1];
        }
        return undefined;
    }

    /* true, false, or null for "the tuple carried no Sellable I could read".
       FastSimon indexes some metafields as the strings "true"/"false", so the
       string forms are handled rather than left to truthiness, where "false"
       would read as true. */
    function variantSellable(variant) {
        var value = variantAttribute(variant, 'Sellable');
        if (typeof value === 'boolean') return value;
        if (value === 'true') return true;
        if (value === 'false') return false;
        return null;
    }

    /* Shippable to THIS shopper. Shopify's own available is true when any
       fulfilling location holds stock, so a size held only in the US
       warehouse reads as buyable to a UK shopper and then cannot ship. The
       PDP already resolves this per market from the split_shipping variant
       metafields, which FastSimon indexes per variant as
       "split shipping.uk available" / "split shipping.us available" (strings).
       UK ships everywhere; US ships to the US only. Returns null where the
       fields are absent so callers fall back rather than guess. */
    function variantMarketSellable(variant) {
        var country = (window.Shopify && window.Shopify.country) || 'GB';
        var uk = variantAttribute(variant, 'split shipping.uk available');
        var us = variantAttribute(variant, 'split shipping.us available');
        var ukOk = uk === undefined ? null : String(uk) === 'true';
        var usOk = us === undefined ? null : String(us) === 'true';
        if (country === 'US') {
            if (usOk === null && ukOk === null) return null;
            return usOk === true || ukOk === true;
        }
        /* Everyone else ships from the UK, so only the UK field can answer.
           Absent means no opinion, never sold out. */
        return ukOk;
    }

    /* Sold out only where the tuples actually carried a Sellable we could read.
       Absent data must not read as "every variant unsellable", which is the
       same trap the length check below already guards against. */
    function everyVariantUnsellable(vra) {
        if (!Array.isArray(vra) || !vra.length) return false;
        var known = 0;
        for (var i = 0; i < vra.length; i++) {
            var sellable = variantSellable(vra[i]);
            if (sellable === null) continue;
            known++;
            if (sellable === true) return false;
        }
        return known > 0;
    }

    /* ------------------------------------------------------------------
       Size pills on FastSimon cards.

       FastSimon draws colour swatches itself but nothing for a Size option,
       so a card for Clean it Zero shows one price and one Add button for a
       product whose two sizes cost GBP 21.00 and GBP 14.00. The vra tuples
       carry everything a pill needs per variant (option value, Price,
       Compare at price, Sellable), so this renders them with no request.

       Only when the size-like option is the product's ONLY option: with a
       colour option as well a pill could not name a single variant without
       combining the two selections, and no product carries both today.
       ------------------------------------------------------------------ */
    /* Money text for the pills. formatMoney exists only where the unit price
       helpers were shipped (theme-rebuild); on production and staging it does
       not, and calling it threw inside the grid loop, aborting every card
       after the first sized one. typeof on an undeclared name is safe. */
    function pillMoney(amount) {
        if (typeof formatMoney === 'function') return formatMoney(amount);
        var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
        var locale = document.documentElement.lang || 'en-GB';
        try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount); }
        catch (e) { return Number(amount).toFixed(2); }
    }

    var SIZE_OPTION_KEY = /^(size|pack size|volume|amount|weight|quantity|count)$/i;
    var SELECTED_VARIANT_ATTR = 'data-sc-variant-id';
    var SELECTED_SELLABLE_ATTR = 'data-sc-variant-sellable';

    function variantOptionKeys(vra) {
        var keys = {};
        (Array.isArray(vra) ? vra : []).forEach(function (variant) {
            variantAttributes(variant).forEach(function (pair) {
                if (Array.isArray(pair) && isOptionKey(pair[0])) keys[String(pair[0])] = true;
            });
        });
        return Object.keys(keys);
    }

    /* FastSimon's tuples can carry attribute keys this file has never seen,
       so "exactly one option key" is too brittle a test: one stray key and a
       shampoo sold in three sizes shows no pills. Pick the size-like key, and
       refuse only where a colour-like key sits beside it, since that product
       would need both selections to name one variant. */
    var COLOUR_OPTION_KEY = /colou?r|shade/i;

    function sizeOptionKey(vra) {
        var keys = variantOptionKeys(vra);
        var size = null;
        for (var i = 0; i < keys.length; i++) {
            var k = keys[i].trim();
            if (COLOUR_OPTION_KEY.test(k)) return null;
            if (!size && SIZE_OPTION_KEY.test(k)) size = keys[i];
        }
        return size;
    }

    /* "GBP:14.00" -> 14. Anything unparseable is null so a pill can fall back
       to leaving the card's price alone rather than writing NaN into it. */
    function tupleMoney(variant, key) {
        var raw = variantAttribute(variant, key);
        if (raw == null) return null;
        var n = parseFloat(String(raw).replace(/[^0-9.,]/g, '').replace(',', '.'));
        return isNaN(n) ? null : n;
    }

    function sizeChoices(productData) {
        var vra = Array.isArray(productData.vra) ? productData.vra : [];
        var key = sizeOptionKey(vra);
        if (!key || vra.length < 2) return null;
        var choices = [];
        var seen = {};
        vra.forEach(function (variant) {
            var label = variantAttribute(variant, key);
            var id = variantId(variant);
            if (label == null || id == null) return;
            if (seen[String(id)]) return;
            seen[String(id)] = true;
            var market = variantMarketSellable(variant);
            choices.push({
                id: String(id),
                label: String(label).trim(),
                sellable: variantSellable(variant) !== false && market !== false,
                market: market,
                price: tupleMoney(variant, 'Price'),
                compare: tupleMoney(variant, 'Compare at price')
            });
        });
        return choices.length > 1 ? choices : null;
    }

    /* The card's price nodes. Known FastSimon classes first; failing that,
       the leaf nodes inside the info area whose text is a money amount, the
       struck one being the compare-at. Our own additions (pills, unit price)
       are skipped so a pill label is never mistaken for the price. */
    function cardPriceNodes(productElement) {
        /* FastSimon renders the price block more than once per card (its
           stylesheet carries separate mobile and desktop blocks), so every
           copy has to move, not the first one found: updating a hidden copy
           and leaving the visible one at the old price is exactly what
           "selected 500ml, still says GBP 8.50" looks like. */
        var priceEls = Array.prototype.slice.call(productElement.querySelectorAll('.fs-price'));
        var compareEls = Array.prototype.slice.call(productElement.querySelectorAll('.fs-compare'));
        if (priceEls.length) return { price: priceEls[0], compare: compareEls[0] || null, prices: priceEls, compares: compareEls };

        var scope = productElement.querySelector('.info-container') || productElement;
        var money = [];
        Array.prototype.forEach.call(scope.querySelectorAll('*'), function (el) {
            if (el.children.length) return;
            if (el.closest('.sc-size-pills, .sc-unit-price, .action-container, .swatches-container')) return;
            if (!/[\u00a3$\u20ac]\s?\d|\d\s?[\u00a3$\u20ac]/.test(el.textContent)) return;
            money.push(el);
        });
        if (!money.length) return { price: null, compare: null, prices: [], compares: [] };
        var struck = money.filter(function (el) {
            var td = (window.getComputedStyle ? window.getComputedStyle(el).textDecorationLine : '') || '';
            return td.indexOf('line-through') !== -1 ||
                   !!el.closest('s, del, strike, .line-through, .compare-container, [class*="compare"]');
        });
        var plain = money.filter(function (el) { return struck.indexOf(el) === -1; });
        return { price: plain[0] || money[0], compare: struck[0] || null, prices: plain.length ? plain : money, compares: struck };
    }

    function setCardPrice(productElement, choice) {
        var nodes = cardPriceNodes(productElement);
        if (choice.price != null) {
            var priceText = pillMoney(choice.price);
            nodes.prices.forEach(function (el) { if (el.textContent.trim() !== priceText) el.textContent = priceText; });
        }
        var onSale = choice.compare != null && choice.price != null && choice.compare > choice.price;
        var compareText = onSale ? pillMoney(choice.compare) : '';
        nodes.compares.forEach(function (el) {
            if (el.textContent.trim() !== compareText) el.textContent = compareText;
            el.style.display = onSale ? '' : 'none';
        });
    }

    function setCardAddState(productElement, choice) {
        var btn = productElement.querySelector('.custom-atc-button');
        if (!btn) return;
        btn.setAttribute('data-variant-id', choice.id);
        var text = btn.querySelector('.js-atc-text');
        if (choice.sellable) {
            btn.disabled = false;
            btn.classList.remove('btn-disabled');
            if (text) text.textContent = btn.hasAttribute('data-preorder') ? 'Pre-order' : 'Add';
        } else {
            btn.disabled = true;
            btn.classList.add('btn-disabled');
            if (text) text.textContent = 'Sold out';
        }
    }

    function selectSizeChoice(productElement, pillsEl, choice) {
        Array.prototype.forEach.call(pillsEl.querySelectorAll('.sc-size-pill'), function (p) {
            p.setAttribute('aria-pressed', p.getAttribute('data-variant-id') === choice.id ? 'true' : 'false');
        });
        productElement.setAttribute(SELECTED_VARIANT_ATTR, choice.id);
        productElement.setAttribute(SELECTED_SELLABLE_ATTR, choice.sellable ? 'true' : 'false');
        var state = sizePillState.get(productElement);
        if (state) state.selectedId = choice.id;
        setCardPrice(productElement, choice);
        setCardAddState(productElement, choice);

        /* Keep the card link on the chosen size so the product page opens on it. */
        Array.prototype.forEach.call(productElement.querySelectorAll('a[href*="/products/"]'), function (link) {
            try {
                var base = (window.location && window.location.origin) || 'https://skincupid.co.uk';
                var url = new URL(link.getAttribute('href'), base);
                url.searchParams.set('variant', choice.id);
                link.setAttribute('href', url.pathname + url.search + url.hash);
            } catch (err) { /* leave it */ }
        });
    }

    /* FastSimon rebuilds a card's info area during hydration, which is what
       repaints the swatch marker, and it takes our pills with it. The choices
       for each card are kept so ensureSizePills can put them back, with the
       shopper's selection intact, and a MutationObserver on the card calls it
       whenever the pills go missing. Bounded like the swatch re-assert so a
       card that fights back settles rather than loops. */
    var sizePillState = new WeakMap();
    var SIZE_PILL_WATCH_ATTR = 'data-sc-size-pills-watched';
    var SIZE_PILL_REBUILD_LIMIT = 20;

    function ensureSizePills(productElement) {
        var state = sizePillState.get(productElement);
        if (!state) return;
        var current = state.choices.filter(function (c) { return c.id === state.selectedId; })[0] || state.choices[0];
        var pillsEl = productElement.querySelector('.sc-size-pills');

        if (!pillsEl) {
            if (state.rebuilds >= SIZE_PILL_REBUILD_LIMIT) return;
            state.rebuilds++;
            renderSizePills(productElement, state.choices, current);
            return;
        }

        /* Pills intact but FastSimon has repainted the price, the button or
           the pressed state underneath them. Re-apply the selection, only when
           something actually differs, so our own writes do not loop. */
        var nodes = cardPriceNodes(productElement);
        var wantPrice = current.price != null ? pillMoney(current.price) : null;
        var priceStale = wantPrice != null && nodes.prices.some(function (el) { return el.textContent.trim() !== wantPrice; });
        var btn = productElement.querySelector('.custom-atc-button');
        var btnStale = btn && btn.getAttribute('data-variant-id') !== current.id;
        var pressed = pillsEl.querySelector('.sc-size-pill[aria-pressed="true"]');
        var pressStale = !pressed || pressed.getAttribute('data-variant-id') !== current.id;
        if (!priceStale && !btnStale && !pressStale) return;
        if (state.rebuilds >= SIZE_PILL_REBUILD_LIMIT) return;
        state.rebuilds++;
        selectSizeChoice(productElement, pillsEl, current);
    }

    function watchSizePills(productElement) {
        if (typeof MutationObserver !== 'function') return;
        if (productElement.getAttribute(SIZE_PILL_WATCH_ATTR) === '1') return;
        productElement.setAttribute(SIZE_PILL_WATCH_ATTR, '1');
        var observer = new MutationObserver(function () { ensureSizePills(productElement); });
        observer.observe(productElement, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-variant-id', 'aria-pressed', 'disabled'] });
    }

    function addSizePills(productElement, productData) {
        if (!productElement || productElement.querySelector('.sc-size-pills')) return;
        var choices = sizeChoices(productData);
        if (!choices) return;
        sizePillState.set(productElement, { choices: choices, selectedId: null, rebuilds: 0 });
        var initial = choices.filter(function (c) { return c.sellable; })[0] || choices[0];
        renderSizePills(productElement, choices, initial);
        watchSizePills(productElement);
        reconcileSizeChoices(productElement, choices, productData);
    }

    function renderSizePills(productElement, choices, initial) {

        var host = productElement.querySelector('.info-container') ||
                   productElement.querySelector('.product-info');
        if (!host) return;

        var pillsEl = document.createElement('div');
        pillsEl.className = 'sc-size-pills';
        pillsEl.setAttribute('role', 'group');
        pillsEl.setAttribute('aria-label', 'Size');

        choices.forEach(function (choice) {
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'sc-size-pill';
            pill.textContent = choice.label;
            pill.title = choice.label + (choice.sellable ? '' : ' (Sold out)');
            pill.setAttribute('data-variant-id', choice.id);
            pill.setAttribute('data-sellable', choice.sellable ? 'true' : 'false');
            pill.setAttribute('aria-pressed', 'false');
            pill.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                selectSizeChoice(productElement, pillsEl, choice);
            });
            pillsEl.appendChild(pill);
        });

        host.appendChild(pillsEl);
        selectSizeChoice(productElement, pillsEl, initial || choices[0]);
    }

    /* FastSimon's stock data has already been wrong on this store in both
       directions, and a pill is a promise about price and availability, so
       each size is checked against Shopify's own product JSON. One request per
       card that has pills, cached per handle, and only a few dozen products in
       the catalogue qualify. Where Shopify disagrees, Shopify wins: price,
       compare-at and sellable are corrected in place and the current selection
       is re-applied so the card follows. */
    function reconcileSizeChoices(productElement, choices, productData) {
        var handle = productHandleFrom(productData) || cardProductHandle(productElement);
        if (!handle) return;
        /* Deferred until the card is near the viewport: FastSimon's own
           prices and stock stand until then, and cards the shopper never
           scrolls to cost no request. */
        whenNearViewport(productElement, function () { reconcileSizeChoicesNow(productElement, choices, handle); });
    }

    function reconcileSizeChoicesNow(productElement, choices, handle) {
        fetchShopifyProduct(handle).then(function (shopifyProduct) {
            var variants = (shopifyProduct && shopifyProduct.variants) || [];
            if (!variants.length) return;
            var changed = false;
            choices.forEach(function (choice) {
                var match = variants.filter(function (v) { return String(v.id) === choice.id; })[0];
                if (!match) return;
                var price = typeof match.price === 'number' ? match.price / 100 : null;
                var compare = typeof match.compare_at_price === 'number' ? match.compare_at_price / 100 : null;
                var sellable = match.available !== false && choice.market !== false;
                if (price != null && price !== choice.price) { choice.price = price; changed = true; }
                if (compare !== choice.compare) { choice.compare = compare; changed = true; }
                if (sellable !== choice.sellable) { choice.sellable = sellable; changed = true; }
                var pill = productElement.querySelector('.sc-size-pill[data-variant-id="' + choice.id + '"]');
                if (pill) {
                    pill.setAttribute('data-sellable', sellable ? 'true' : 'false');
                    pill.title = choice.label + (sellable ? '' : ' (Sold out)');
                }
            });
            if (!changed) return;
            var currentId = productElement.getAttribute(SELECTED_VARIANT_ATTR);
            var current = choices.filter(function (c) { return c.id === currentId; })[0];
            /* If the size we defaulted to turns out to be sold out, move to one
               that is not, as the first render would have done with true data. */
            if (!current || !current.sellable) {
                current = choices.filter(function (c) { return c.sellable; })[0] || current || choices[0];
            }
            var pillsEl = productElement.querySelector('.sc-size-pills');
            if (pillsEl) selectSizeChoice(productElement, pillsEl, current);
        }).catch(function () { /* FastSimon's data stands */ });
    }

    /**
     * Check if product is out of stock
     */
    function isProductOutOfStock(productData) {
        const config = window.SwymBackInStockConfig || {};
        
        if (config.checkAvailability && typeof config.checkAvailability === 'function') {
            return !config.checkAvailability(productData);
        }
        
        if (productData.isSoldOut === true) return true;
        
        return everyVariantUnsellable(productData.vra);
    }

    /* Shared Shopify availability lookups, keyed by handle. FastSimon re-renders
       the grid on every filter and pagination change, so caching keeps a browse
       session to one request per product instead of one per render. */
    var shopifyProductCache = new Map();

    function productHandleFrom(productData) {
        var url = productData.productURL || productData.u;
        if (!url) return null;
        var handle = url.split('/products/')[1];
        return handle ? handle.split('?')[0] : null;
    }

    function fetchShopifyProduct(handle) {
        if (shopifyProductCache.has(handle)) return shopifyProductCache.get(handle);
        var request = fetch('/products/' + handle + '.js')
            .then(res => (res.ok ? res.json() : null))
            .catch(() => null);
        shopifyProductCache.set(handle, request);
        return request;
    }

    /**
     * Verify stock against Shopify — swap ATC → Notify if actually OOS
     * Runs async after initial render so page stays fast
     */
        function verifyShopifyStock(productElement, productData) {
            var tags = productData.tags || productData.lowerTags || [];
            if (!tags.some(t => t === 'FS_IN_STOCK' || t === 'fs_in_stock')) return;

            var handle = productHandleFrom(productData);
            if (!handle) return;

            fetchShopifyProduct(handle)
                .then(shopifyProduct => {
                    if (shopifyProduct && shopifyProduct.available === false) {
                        var atcBtn = productElement.querySelector('.custom-atc-button, .custom-subscribe-button');
                        if (atcBtn) atcBtn.remove();
                        productData.isSoldOut = true;
                        addNotifyMeButton(productElement, productData);
                    }
                });
        }

    /**
     * The check above only ever demotes ATC → Notify. When FastSimon's index is
     * stale the other way — it says sold out while Shopify has stock — nothing
     * corrected it, so the card sat on Notify Me until the feed resynced.
     * This promotes it back, trusting Shopify's variant list rather than
     * FastSimon's stale one for the variant id.
     */
    var restockChecksRun = 0;
    var RESTOCK_CHECK_LIMIT = 30;

    /* FastSimon indexes per-warehouse availability on each variant as
       "split shipping.uk available" / "split shipping.us available". Shopify's
       own product.available is true when ANY location holds stock, so for a US
       shopper promoting on that alone would put Add to cart on something the
       US warehouse cannot fulfil. The UK warehouse ships to every market, so
       for everyone else Shopify's availability is the truth and this returns
       null. That also sidesteps the flags going stale: they are written by a
       Flow on inventory changes, which never fires for Shopify Bundles (the
       starter sets), so a bundle can sit on "uk available: false" for months
       while it is in stock. Returns null when the field is absent so callers
       can fall back rather than guess. */
    function marketSplitShippingAvailable(productData) {
        var country = (window.Shopify && window.Shopify.country) || 'GB';
        if (country !== 'US') return null;

        var variants = Array.isArray(productData.vra) ? productData.vra : [];
        if (!variants.length) return null;

        var key = 'split shipping.us available';

        var fieldSeen = false;
        var anyAvailable = false;
        variants.forEach(function (variant) {
            if (!variant || typeof variant[key] === 'undefined') return;
            fieldSeen = true;
            if (String(variant[key]) === 'true') anyAvailable = true;
        });

        return fieldSeen ? anyAvailable : null;
    }

    function verifyShopifyRestock(productElement, productData) {
        var handle = productHandleFrom(productData);
        if (!handle) return;

        /* Don't promote something the shopper's own warehouse can't ship. */
        if (marketSplitShippingAvailable(productData) === false) return;

        /* Only uncached handles count toward the cap, so paging back and forth
           through a mostly sold-out collection never re-spends the budget. */
        if (!shopifyProductCache.has(handle)) {
            if (restockChecksRun >= RESTOCK_CHECK_LIMIT) return;
            restockChecksRun++;
        }

        fetchShopifyProduct(handle)
            .then(shopifyProduct => {
                if (!shopifyProduct || shopifyProduct.available !== true) return;

                var sellable = (shopifyProduct.variants || []).filter(v => v.available)[0];
                if (!sellable) return;

                var notifyBtn = productElement.querySelector('.custom-notify-button');
                if (notifyBtn) notifyBtn.remove();

                /* Clone rather than mutate: dropping the stale vra makes
                   checkAvailability pass and makes the button builder fall
                   through to Shopify's variant id. */
                addAddToCartButton(productElement, Object.assign({}, productData, {
                    isSoldOut: false,
                    vra: null,
                    variant_id: sellable.id
                }));
            });
    }

    /* ============================================================================
       CONTAINER MANAGEMENT
       ============================================================================ */

    /**
     * Find or create action container inside product-info element
     */
    function findOrCreateActionContainer(productElement) {
        if (!productElement) return null;

        const productInfo = productElement.querySelector('.product-info');
        if (!productInfo) {
            console.warn('[Container] .product-info not found in product card');
            return null;
        }

        let actionContainer = productInfo.querySelector('.action-container');
        
        if (!actionContainer) {
            actionContainer = document.createElement('div');
            actionContainer.className = 'action-container';
            productInfo.appendChild(actionContainer);
        }

        return actionContainer;
    }

    /**
     * Move element within product card
     */
    function moveElementWithinProduct(productElement, targetClass, containerClass, isFirstChild = false) {
        if (!productElement) return;
        const target = productElement.querySelector(targetClass);
        const container = productElement.querySelector(containerClass);

        if (target && container) {
            isFirstChild ? container.prepend(target) : container.appendChild(target);
        }
    }

    /* ============================================================================
       ADD TO CART
       ============================================================================ */

    /**
     * Create and add Add to Cart button to product card
     */
    function addAddToCartButton(productElement, productData) {
        if (isProductOutOfStock(productData)) return;

        /* A subscription can't go in the cart without a delivery plan, so it
           links through instead. Checked here rather than only in
           decorateProductCard so the restock path, which also builds this
           button, does the same. */
        if (isSubscriptionProduct(productData)) {
            addSubscribeButton(productElement, productData);
            return;
        }

        const actionContainer = findOrCreateActionContainer(productElement);
        if (!actionContainer) return;
        if (actionContainer.querySelector('.custom-atc-button')) return;

        /* Quick add buys vra[0]. isProductOutOfStock above only establishes
           that SOME variant is sellable, so on a multi-variant product this
           could offer a sold-out variant, and the shopper has no way to say
           otherwise: the swatches FastSimon renders report colours to the
           hook, not variants. Substituting the first sellable variant is not
           safe either, because vra carries no price and sizes are priced
           separately (Clean it Zero is GBP 21.00 for 100ml, GBP 14.00 for
           50ml), so we could charge for a variant the card never priced.

           Single variant is unambiguous, so it adds straight to the cart.
           Anything with a choice to make opens the quick view, where the
           shopper picks against that variant's own price and stock. Quick add
           stays on every card either way. */
        const vra = Array.isArray(productData.vra) ? productData.vra : [];
        const needsVariantChoice = vra.length > 1;
        const quickViewHandle = needsVariantChoice ? productHandleFrom(productData) : null;
        /* No handle means no way to offer the choice, so offer nothing. */
        if (needsVariantChoice && !quickViewHandle) return;

        const variantId = getNestedProperty(productData, 'vra.0.v_id') || 
                         productData.variant_id || 
                         productData.id;

        const button = document.createElement('button');
        button.type = 'submit';
        button.name = 'add';
        button.className = 'custom-atc-button btn btn-add min-h-[38px] max-lg:!py-2.5 max-lg:!px-3 js-atc-btn w-fit !translate-y-0';
        button.setAttribute('data-variant-id', variantId);
        const preOrder = isPreOrderProduct(productData);
        if (preOrder) button.setAttribute('data-preorder', '1');
        
        button.setAttribute('aria-busy', 'false');
        button.innerHTML = `
            <span class="js-atc-text">${preOrder ? 'Pre-order' : 'Add'}</span>
            <span aria-hidden="true" class="flex size-4 btn-icon js-atc-icon">
                <svg width="100%" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.5925 23.185L0.757812 23.185L2.41136 6.67358L19.939 6.67358L21.5925 23.185Z" stroke="#0F3062" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M6.13086 6.16268C6.13086 3.42783 8.39622 1.21948 11.1742 1.21948C13.9521 1.21948 16.2175 3.44246 16.2175 6.16268" stroke="#0F3062" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
            </span>
            <span aria-hidden="true" class="font-light leading-none text-base/none lg:hidden js-atc-plus" style="margin-left:-0.375rem;">+</span>
            <span aria-hidden="true" class="hidden size-4 js-atc-loading">
                <svg class="w-full h-full animate-spin fill-secondary" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path>
                </svg>
            </span>
        `;

        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            /* A size pill has named the variant outright, with its own price
               and Sellable from the index, so there is no choice left for the
               quick view to offer: add that variant. A sold-out choice leaves
               the button disabled, so this only ever runs for a sellable one. */
            var chosen = productElement.getAttribute(SELECTED_VARIANT_ATTR);
            if (chosen) {
                if (productElement.getAttribute(SELECTED_SELLABLE_ATTR) === 'false') return;
                handleAddToCart(button, chosen);
                return;
            }

            /* A shade the shopper picked on the card names one variant, so
               there is nothing left for the quick view to ask: add it. A
               shade that cannot be bought here opens the quick view on that
               shade rather than doing nothing, so they can see why and
               switch to another. */
            var shade = chosenSwatchVariant(productElement);
            if (shade) {
                if (shade.sellable) {
                    handleAddToCart(button, shade.id);
                    return;
                }
                if (quickViewHandle) {
                    executeQuickView(quickViewHandle, button, shade.id);
                    return;
                }
            }

            if (quickViewHandle) {
                executeQuickView(quickViewHandle, button, shade && shade.id);
                return;
            }

            /* Do not trust FastSimon for stock. Its SDK declares vra entries as
               [variantId, options] tuples and carries no availability field
               anywhere in its types, so the `sellable` flag this file reads
               above may simply be undefined, in which case nothing is ever
               treated as sold out. Confirm against Shopify instead: one request
               per click, cached per handle, so browsing costs nothing and only
               a real purchase attempt pays for it. An unknown product or an
               unrecognised variant falls through and lets Shopify's own cart be
               the judge, which is how this behaved before. */
            var handle = productHandleFrom(productData);
            if (!handle) {
                handleAddToCart(button, variantId);
                return;
            }
            Promise.resolve(fetchShopifyProduct(handle)).then(function (shopifyProduct) {
                /* Shopify refuses a cart add without a selling plan when the
                   product is subscription only, and the plan is picked on the
                   product page. Catches one that is missing the subscription
                   tag the card keys on. */
                if (shopifyProduct && shopifyProduct.requires_selling_plan) {
                    window.location.href = productData.productURL || productData.u;
                    return;
                }
                var variants = (shopifyProduct && shopifyProduct.variants) || [];
                var match = variants.filter(function (v) {
                    return String(v.id) === String(variantId);
                })[0];
                var soldOut = shopifyProduct &&
                    (shopifyProduct.available === false || (match && match.available === false));
                if (soldOut) {
                    /* Show the shopper the real state rather than failing silently. */
                    executeQuickView(handle, button, variantId);
                    return;
                }
                handleAddToCart(button, variantId);
            }).catch(function () {
                handleAddToCart(button, variantId);
            });
        });

        actionContainer.appendChild(button);
    }

    /**
     * Handle add to cart button click
     */
function handleAddToCart(button, variantId) {
    if (!variantId) {
        console.error('[ATC] No variant ID provided');
        return;
    }

    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    const loadingIcon = button.querySelector('.js-atc-loading');
    const btnIcon = button.querySelector('.js-atc-icon');
    const btnPlus = button.querySelector('.js-atc-plus');
    const btnText = button.querySelector('.js-atc-text');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (btnText) btnText.textContent = 'Adding…';
    btnIcon?.classList.add('hidden');
    btnPlus?.classList.add('hidden');
    loadingIcon?.classList.remove('hidden');

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
        })
    })
    .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
    })
    .then(() => {
        // Refresh drawer contents + header summary in parallel, then open
        // the drawer once contents have been re-rendered.
        window.cart?.cartContents?.();
        if (window.cart && typeof window.cart.redrawCart === 'function') {
            window.cart.redrawCart('open');
        } else {
            document.querySelector('[data-cart-btn]')?.click();
        }

        if (btnText) {
            btnText.textContent = 'Added!';
            setTimeout(() => {
                btnText.textContent = button.hasAttribute('data-preorder') ? 'Pre-order' : 'Add';
            }, 2000);
        }
    })
    .catch(err => {
        console.error('[ATC] Error:', err);
        if (btnText) btnText.textContent = button.hasAttribute('data-preorder') ? 'Pre-order' : 'Add';
        alert('Sorry, there was an error adding this item to your cart. Please try again.');
    })
    .finally(() => {
        button.disabled = false;
        button.setAttribute('aria-busy', 'false');
        loadingIcon?.classList.add('hidden');
        btnIcon?.classList.remove('hidden');
        btnPlus?.classList.remove('hidden');
    });
}

    /* ============================================================================
       NOTIFY ME (BACK IN STOCK)
       ============================================================================ */

    /**
     * Booking / appointment products. These cannot be added straight to the cart
     * from a grid: a booking with no time slot attached is not fulfillable, so
     * the card links through to the product page where the app's time picker
     * lives. Keyed on a tag rather than product type because tags are what
     * FastSimon reliably exposes on the grid payload.
     */
    /* Pre-order cards. The theme flags a pre-order with the custom.pre_order
       metafield, which FastSimon only exposes if that metafield is indexed, so
       the grid keys on a "pre-order" tag first and falls back to the attribute.
       The ship date comes from the theme setting (window.__scPreorderShipDate,
       set in snippets/FSHooks.liquid), the same wording the theme cards use. */
    function isPreOrderProduct(productData) {
        var tags = productData.tags || productData.lowerTags || [];
        if (Array.isArray(tags) && tags.some(function (t) { return /^pre-?order$/i.test(String(t).trim()); })) return true;
        if (Array.isArray(productData.att)) {
            for (var i = 0; i < productData.att.length; i++) {
                var pair = productData.att[i];
                if (!Array.isArray(pair) || !/^custom\.pre[ _-]?order$/i.test(String(pair[0]))) continue;
                var val = Array.isArray(pair[1]) ? pair[1][0] : pair[1];
                if (String(val).toLowerCase() === 'true') return true;
            }
        }
        return false;
    }
    function addPreOrderLine(productElement) {
        var title = productElement.querySelector('.fs-serp-product-title');
        if (!title || title.querySelector('.sc-preorder-line')) return;
        var ship = (window.__scPreorderShipDate || '').trim();
        var line = document.createElement('span');
        line.className = 'sc-preorder-line';
        var label = document.createElement('span');
        label.className = 'sc-preorder-line__label';
        label.textContent = 'Pre-order';
        line.appendChild(label);
        if (ship) line.appendChild(document.createTextNode(' \u00b7 ships ' + ship));
        title.appendChild(line);
    }

    function isBookingProduct(productData) {
        var tags = productData.tags || productData.lowerTags || [];
        if (!Array.isArray(tags)) return false;
        return tags.some(function (t) { return String(t).toLowerCase() === 'booking'; });
    }

    function addBookingButton(productElement, productData) {
        const actionContainer = findOrCreateActionContainer(productElement);
        if (!actionContainer || actionContainer.querySelector('.custom-booking-button')) return;

        const url = productData.productURL || productData.u;
        if (!url) return;

        const link = document.createElement('a');
        /* No js-atc-btn: core.js must not treat this as an add to cart. */
        link.className = 'custom-booking-button btn btn-add min-h-[38px] max-lg:!py-2.5 max-lg:!px-3 w-fit !translate-y-0';
        link.href = url;
        link.innerHTML = '<span>Book now</span>';
        actionContainer.appendChild(link);
    }

    /**
     * Subscription products (the subscription box). Shopify refuses a cart add
     * without a selling plan when one-time purchase is switched off, and the
     * plan (delivery frequency) is picked in the Loop Subscriptions widget,
     * which only exists on the product page. So, like a booking, the card
     * links through rather than adding, and offers no quick view, whose form
     * has no plan picker either. Keyed on the "subscription" tag for the same
     * reason as bookings: FastSimon's grid payload carries tags but not
     * requires_selling_plan.
     */
    function isSubscriptionProduct(productData) {
        var tags = productData.tags || productData.lowerTags || [];
        if (!Array.isArray(tags)) return false;
        return tags.some(function (t) { return String(t).toLowerCase() === 'subscription'; });
    }

    function addSubscribeButton(productElement, productData) {
        const actionContainer = findOrCreateActionContainer(productElement);
        if (!actionContainer || actionContainer.querySelector('.custom-subscribe-button')) return;

        const url = productData.productURL || productData.u;
        if (!url) return;

        const link = document.createElement('a');
        /* No js-atc-btn: core.js must not treat this as an add to cart. */
        link.className = 'custom-subscribe-button btn btn-add min-h-[38px] max-lg:!py-2.5 max-lg:!px-3 w-fit !translate-y-0';
        link.href = url;
        link.innerHTML = '<span>Subscribe</span>';
        actionContainer.appendChild(link);
    }

    /**
     * Create and add Notify Me button to product card
     */
    function addNotifyMeButton(productElement, productData) {
        if (!isProductOutOfStock(productData)) return;

        const actionContainer = findOrCreateActionContainer(productElement);
        if (!actionContainer || actionContainer.querySelector('.custom-notify-button')) return;

        const config = window.SwymBackInStockConfig || {};
        const mapping = config.productDataMapping || {};

        let variantId = getNestedProperty(productData, mapping.variantId || 'variantId') || 
                       productData.variant_id || 
                       productData.id;
        
        if (!variantId && productData.vra?.length > 0) {
            variantId = productData.vra[0].v_id;
        }

        const productId = getNestedProperty(productData, mapping.id || 'id') || 
                         productData.productId || 
                         productData.parentID;

        let productUrl = getNestedProperty(productData, mapping.url || 'productURL') || 
                        productData.url || 
                        productData.u;
        
        if (productUrl && !productUrl.startsWith('http')) {
            productUrl = window.location.origin + productUrl;
        }

        const imageUrl = getNestedProperty(productData, mapping.image || 'imageURL') ||
                        productData.imageURL || 
                        productData.t ||
                        productData.imageURL2 ||
                        productData.t2;

        const price = parseFloat(getNestedProperty(productData, mapping.price || 'price') || 
                                productData.price || 
                                productData.p || 
                                0);

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'custom-notify-button btn btn-add min-h-[38px] max-lg:!py-2.5 max-lg:!px-3 w-fit !translate-y-0';
        button.setAttribute('data-epi', variantId);
        button.setAttribute('data-empi', productId);
        button.setAttribute('data-du', productUrl);
        button.setAttribute('data-image', imageUrl);
        button.setAttribute('data-price', Math.round(price * 100));
        button.textContent = 'Notify me';

        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            handleNotifyMeClick(button);
        });

        actionContainer.appendChild(button);
    }

    /**
     * Handle notify me button click - Opens SWYM modal
     */
    async function handleNotifyMeClick(button) {
        console.log('[Notify] Opening SWYM popup');
        
        try {
            const swat = await initializeSwym();
            
            if (!swat || typeof swat.addToWatchList !== 'function') {
                console.error('[Notify] SWYM addToWatchList not available');
                alert('Sorry, the notification service is not available right now.');
                return;
            }

            const product = {
                epi: +button.getAttribute('data-epi'),
                empi: +button.getAttribute('data-empi'),
                du: button.getAttribute('data-du'),
                iu: button.getAttribute('data-image'),
                pr: button.getAttribute('data-price'),
                et: 8 // Event type for back-in-stock
            };

            swat.addToWatchList(null, product, (response) => {
                console.log('[Notify] Popup successfully opened', response);
            }, null, 'backinstock');

        } catch (error) {
            console.error('[Notify] Error:', error);
            alert('Sorry, there was an error. Please try again.');
        }
    }

    /* ============================================================================
       QUICK VIEW
       ============================================================================ */

    /**
     * Execute quick view modal
     */
    /* variantId, when known, is the shade or size the shopper already chose
       on the card. Shopify resolves ?variant= into
       product.selected_or_first_available_variant, so the modal renders with
       that option already checked and its own price, rather than opening on
       whichever variant happens to be first. */
    async function executeQuickView(handle, trigger, variantId) {
        const modal = document.querySelector('[data-quick-view-modal]');
        const modalContent = modal?.querySelector('[data-quick-view-content]');
        if (!modal || !modalContent || !handle) return;

        const spinner = trigger.querySelector('[data-quick-view-spinner]');
        spinner?.classList.remove('hidden');
        trigger.disabled = true;

        try {
            let quickViewUrl = `/products/${handle}?view=quick-view`;
            if (variantId) quickViewUrl += `&variant=${encodeURIComponent(variantId)}`;
            const res = await fetch(quickViewUrl);
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const modalPopupHTML = doc.querySelector('[data-quick-view-template-content]');

            if (modalPopupHTML) {
                modalContent.innerHTML = modalPopupHTML.innerHTML;

                /* Wire up variant selection. core.js binds this on load for the
                   product template and for its own quick view, but this modal
                   is filled by innerHTML from outside that bundle, so without
                   this call the radios change nothing: the price, the compare
                   at price and the master variant id all stay on whatever the
                   first variant was.

                   The argument has to be an ANCESTOR of .product-info, not the
                   .product-info element itself: core.js builds its selectors as
                   `parent + ' .product-info ...'`, a descendant combinator. That
                   is why its own quick view passes .quick-view-modal-inner, the
                   wrapper it appends .product-info into. Here .product-info sits
                   on [data-quick-view-content], so the modal is the ancestor to
                   scope by. Guarded on #product-variants because the initialiser
                   dereferences it, and single-variant products render no such
                   block. */
                try {
                    if (typeof window.productVariants === 'function' &&
                        modalContent.querySelector('#product-variants')) {
                        window.productVariants('[data-quick-view-modal]');
                    }
                } catch (err) {
                    console.error('[QuickView] variant init failed', err);
                }
                
                modal.classList.remove('opacity-0', 'pointer-events-none');
                modal.classList.add('opacity-100');
                document.body.classList.add('overflow-hidden');

                /* Adding from the quick view. Nothing here bound the form, so
                   the submit fell through to cart.js, which adds the item and
                   opens the drawer but closes only the theme's own quick view
                   modal, leaving this one open over the drawer. Handle the add
                   here instead: post the form as it stands (so quantity and
                   any properties travel), and on success close this modal and
                   open the drawer the same way the card button does. */
                const qvForm = modalContent.querySelector('form[data-type="add-to-cart-form"]');
                if (qvForm && !qvForm.hasAttribute('data-sc-qv-bound')) {
                    qvForm.setAttribute('data-sc-qv-bound', '1');
                    qvForm.addEventListener('submit', (e) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        const submitBtn = qvForm.querySelector('button[type="submit"]');
                        if (submitBtn && (submitBtn.disabled || submitBtn.getAttribute('aria-busy') === 'true')) return;
                        if (submitBtn) { submitBtn.disabled = true; submitBtn.setAttribute('aria-busy', 'true'); }

                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Accept': 'application/json' },
                            body: new FormData(qvForm)
                        })
                        .then((res) => res.ok ? res.json() : res.json().then((err) => { throw err; }))
                        .then(() => {
                            modal.classList.remove('opacity-100');
                            modal.classList.add('opacity-0', 'pointer-events-none');
                            document.body.classList.remove('overflow-hidden');
                            window.cart?.cartContents?.();
                            if (window.cart && typeof window.cart.redrawCart === 'function') {
                                window.cart.redrawCart('open');
                            } else {
                                document.querySelector('[data-cart-btn]')?.click();
                            }
                        })
                        .catch((err) => {
                            console.error('[QuickView] add to cart failed', err);
                            const msg = (err && (err.description || err.message)) || 'Sorry, this item could not be added. Please try again.';
                            alert(msg);
                        })
                        .finally(() => {
                            if (submitBtn) { submitBtn.disabled = false; submitBtn.setAttribute('aria-busy', 'false'); }
                        });
                    }, true);
                }

                const closeBtn = modalContent.querySelector('[data-quick-view-close]');
                if (closeBtn) {
                    closeBtn.onclick = (e) => {
                        e.preventDefault();
                        modal.classList.remove('opacity-100');
                        modal.classList.add('opacity-0', 'pointer-events-none');
                        document.body.classList.remove('overflow-hidden');
                    };
                }

                if (typeof initQuickView === 'function') {
                    initQuickView();
                }
            }
        } catch (err) {
            console.error('[QuickView] Error:', err);
        } finally {
            spinner?.classList.add('hidden');
            trigger.disabled = false;
        }
    }

    /**
     * Add quick view button (desktop)
     */
    function addQuickViewButton(productElement, productURL) {
        if (!productURL || productElement.querySelector('[data-quick-view-trigger].hidden.lg\\:flex')) return;

        const imgContainer = productElement.querySelector('.fs-product-main-image-wrapper .image-wrapper');
        if (!imgContainer) return;

        const handle = productURL.split('/products/')[1]?.split('?')[0] || '';

        const btn = document.createElement('button');
        btn.setAttribute('data-quick-view-trigger', '');
        btn.setAttribute('data-product-handle', handle);
        btn.type = 'button';
        btn.className = 'hidden lg:flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 group-hover:pointer-events-auto pointer-events-none z-10 transition-opacity p-2 justify-center text-center text-[14px] rounded-full bg-white w-[160px] text-secondary gap-2 items-center';
        
        btn.innerHTML = `
            <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.4605 3.05901C9.76472 2.92077 9.2145 3.23901 9.0902 3.83744C8.97236 4.40555 9.32809 4.95943 9.88921 5.08122C10.5098 5.21595 10.9917 4.84725 11.1699 4.10135C11.6265 5.02227 11.4627 6.6366 10.1766 7.55272C8.92434 8.44481 7.166 8.19106 6.22108 6.98239C5.26304 5.7569 5.42779 3.99878 6.59897 2.99063C7.81042 1.94773 9.50042 2.13125 10.4605 3.05919V3.05901Z" fill="#0F3062"></path>
                <path d="M16.3349 5.22673C15.995 4.616 15.5907 4.05114 15.1185 3.53302C12.9885 1.19543 9.69324 0.139132 6.59565 0.837213C3.97158 1.42858 2.00014 2.90206 0.672524 5.21484C0.610535 5.32291 0.611051 5.40652 0.663226 5.51341C0.935809 6.07113 1.26418 6.59061 1.64008 7.06659C1.69708 7.13881 1.75545 7.21001 1.81469 7.28036C1.82519 7.29294 1.83587 7.30551 1.84654 7.31792C3.47739 9.23 5.89981 10.3755 8.50545 10.375C8.97295 10.3731 9.43839 10.3425 9.89781 10.2651C10.0039 10.2472 10.1094 10.2268 10.2148 10.2037C13.0119 9.58991 15.0557 8.0194 16.3413 5.49013C16.3887 5.397 16.3857 5.31816 16.3349 5.22673Z" stroke="#0F3062" stroke-width="0.580263" stroke-miterlimit="10"></path>
            </svg>
            <span data-quick-view-spinner class="hidden w-3 h-3 border-2 rounded-full border-t-transparent border-[#0F3062] animate-spin"></span>
            <span data-quick-view-text>Quick View</span>
        `;

        btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var picked = chosenSwatchVariant(productElement);
            executeQuickView(handle, this, picked && picked.id);
        });

        imgContainer.appendChild(btn);
    }

    /**
     * Add quick view button (mobile)
     */
    function addQuickViewButtonMobile(productElement, productURL) {
         // Hide Quick View on phones only (<= 480px)
        if (window.matchMedia('(max-width: 480px)').matches) return;

        if (!productURL || productElement.querySelector('[data-quick-view-trigger].lg\\:hidden')) return;

        const infoContainer = productElement.querySelector('.info-container');
        if (!infoContainer) return;

        const handle = productURL.split('/products/')[1]?.split('?')[0] || '';

        const btn = document.createElement('button');
        btn.setAttribute('data-quick-view-trigger', '');
        btn.setAttribute('data-product-handle', handle);
        btn.type = 'button';
        btn.className = 'quick-view-mobile lg:hidden relative bg-melon-primary flex items-center justify-center text-center gap-2 text-xs p-2 rounded-full';
        
        btn.innerHTML = `
            <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.4605 3.05901C9.76472 2.92077 9.2145 3.23901 9.0902 3.83744C8.97236 4.40555 9.32809 4.95943 9.88921 5.08122C10.5098 5.21595 10.9917 4.84725 11.1699 4.10135C11.6265 5.02227 11.4627 6.6366 10.1766 7.55272C8.92434 8.44481 7.166 8.19106 6.22108 6.98239C5.26304 5.7569 5.42779 3.99878 6.59897 2.99063C7.81042 1.94773 9.50042 2.13125 10.4605 3.05919V3.05901Z" fill="#0F3062"></path>
                <path d="M16.3349 5.22673C15.995 4.616 15.5907 4.05114 15.1185 3.53302C12.9885 1.19543 9.69324 0.139132 6.59565 0.837213C3.97158 1.42858 2.00014 2.90206 0.672524 5.21484C0.610535 5.32291 0.611051 5.40652 0.663226 5.51341C0.935809 6.07113 1.26418 6.59061 1.64008 7.06659C1.69708 7.13881 1.75545 7.21001 1.81469 7.28036C1.82519 7.29294 1.83587 7.30551 1.84654 7.31792C3.47739 9.23 5.89981 10.3755 8.50545 10.375C8.97295 10.3731 9.43839 10.3425 9.89781 10.2651C10.0039 10.2472 10.1094 10.2268 10.2148 10.2037C13.0119 9.58991 15.0557 8.0194 16.3413 5.49013C16.3887 5.397 16.3857 5.31816 16.3349 5.22673Z" stroke="#0F3062" stroke-width="0.580263" stroke-miterlimit="10"></path>
            </svg>
            <span data-quick-view-spinner class="w-3 h-3 border-2 rounded-full border-t-transparent border-primary animate-spin hidden"></span>
            <span data-quick-view-text>Quick View</span>
        `;

        btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var picked = chosenSwatchVariant(productElement);
            executeQuickView(handle, this, picked && picked.id);
        });

        infoContainer.appendChild(btn);
    }

    /* ============================================================================
       PRODUCT BADGES
       ============================================================================ */

    /**
     * Add product card badge to image container
     */
    function addProductCardBadge(productElement, productData) {
        if (productElement.querySelector('.product-card-badge')) return;

        const imageWrapper = productElement.querySelector('.img-container');
        if (!imageWrapper) {
            console.warn('[Badge] .img-container not found');
            return;
        }

        if (!productData.att || !Array.isArray(productData.att)) return;

        let badgeValue = null;
        for (const [attrName, attrValues] of productData.att) {
            if (attrName === 'Custom.product card badge' || attrName === 'Custom.Product Card Badge') {
                if (Array.isArray(attrValues) && attrValues.length > 0) {
                    badgeValue = attrValues[0];
                } else if (typeof attrValues === 'string') {
                    badgeValue = attrValues;
                }
                break;
            }
        }

        if (!badgeValue || badgeValue.trim() === '') return;

        const badge = document.createElement('span');
        badge.className = 'product-card-badge absolute inline-block -top-[9px] left-0 right-0 mx-auto max-sm:text-[8px] text-xs text-white uppercase bg-primary rounded-lg z-[2] py-[2px] px-2 w-fit';
        badge.textContent = badgeValue;

        imageWrapper.appendChild(badge);
    }

    /**
     * Add product card feature badges to image container
     */
    function addProductCardFeatures(productElement, productData) {
        if (productElement.querySelector('.features-badges')) return;

        const imageContainer = productElement.querySelector('.img-container');
        if (!imageContainer) {
            console.warn('[Features] .img-container not found');
            return;
        }

        if (!productData.att || !Array.isArray(productData.att)) return;

        let featureValues = null;
        for (const [attrName, attrValues] of productData.att) {
            if (attrName === 'Custom.product card features' || attrName === 'Custom.Product Card Features') {
                if (Array.isArray(attrValues) && attrValues.length > 0) {
                    featureValues = attrValues;
                }
                break;
            }
        }

        if (!featureValues || featureValues.length === 0) return;

        const featuresContainer = document.createElement('div');
        featuresContainer.className = 'features-badges flex flex-row gap-1 items-center absolute z-[2] left-1.5 bottom-1.5 flex-wrap';

        featureValues.forEach(feature => {
            if (feature && feature.trim() !== '') {
                const badge = document.createElement('span');
                badge.className = 'max-sm:text-[8px] text-xs uppercase bg-pink-light rounded-lg py-[2px] px-2 w-fit';
                badge.style.color = '#0f3062 !important';
                badge.textContent = feature;
                featuresContainer.appendChild(badge);
            }
        });

        imageContainer.appendChild(featuresContainer);
    }

    /* ============================================================================
       COLOR SWATCHES
       ============================================================================ */

    /**
     * Apply custom colors to swatches
     */
    function applySwatchCustomColors(colorsData, swatchesElement) {
        if (!Array.isArray(colorsData) || colorsData.length === 0 || !swatchesElement) return;

        // Ensure selected class exists on initial render
        const SELECTED_GUARD = 'data-fs-selected-initialized';
        if (swatchesElement.getAttribute(SELECTED_GUARD) !== '1') {
            const hasSelected = !!swatchesElement.querySelector('.product-swatch.product-swatch-selected');
            if (!hasSelected) {
                const firstSwatch = swatchesElement.querySelector('.color-swatch-container.fs-color-swatch-container .product-swatch');
                firstSwatch?.classList.add('product-swatch-selected');
            }
            swatchesElement.setAttribute(SELECTED_GUARD, '1');
        }

        // Build lookup maps
        const bySlug = new Map();
        const byLabel = new Map();

        for (const item of colorsData) {
            const label = (item.colour || item.color || '').trim();
            const custom = (item['custom.colour'] || '').trim();
            if (!label || !custom) continue;

            byLabel.set(label, custom);
            bySlug.set(label.toLowerCase().replace(/\s+/g, '_'), custom);
        }

        // Apply to each swatch dot
        const swatchDots = swatchesElement.querySelectorAll('.swatch-color');
        swatchDots.forEach(dot => {
            if (dot.getAttribute('data-fs-swatch-colored') === '1') return;

            let foundColor = null;

            // Match via class "fast-swatch-color-#101_joyful"
            for (const cls of dot.classList) {
                if (!cls.startsWith('fast-swatch-color-')) continue;
                const token = cls.replace('fast-swatch-color-', '');
                if (bySlug.has(token)) {
                    foundColor = bySlug.get(token);
                    break;
                }
            }

            // Fallback: visible label
            if (!foundColor) {
                const container = dot.closest('.fs-color-swatch-container');
                const labelEl = container?.querySelector('.fs-color-name');
                const labelText = (labelEl?.textContent || '').trim();
                if (labelText && byLabel.has(labelText)) {
                    foundColor = byLabel.get(labelText);
                }
            }

            if (!foundColor) return;

            dot.style.setProperty('--swatch-background-color', foundColor);
            dot.setAttribute('data-fs-swatch-colored', '1');
        });
    }

    /* ------------------------------------------------------------------
       FastSimon marks a swatch sold out from its own index, drawing a .ban
       icon and setting data-disabled, and that index can lag Shopify badly:
       on LAKA Fruity Glam Tint it struck out three shades holding 796, 497
       and 249 units. A false sold-out on a grid card costs the sale outright,
       because the shopper never clicks the shade.

       This corrects in one direction only. It clears the marker when Shopify
       says the colour is purchasable, and never adds one FastSimon did not
       draw, so a genuinely sold-out shade keeps its icon. Cards with no marked
       swatch cost nothing, and the per-handle cache means a browse session
       spends one request per affected product rather than one per render.
       ------------------------------------------------------------------ */
    /* FastSimon's index is RIGHT about these shades. Its ssr-grid payload
       carries ["Sellable",[true]] for every variant we have seen wrongly struck
       out, and the server-rendered markup carries no fs-swatch-out-of-stock at
       all: the class is added client-side after hydration. So the authoritative
       correction is their own vra, which arrives in the serp-product-grid hook
       one render earlier than the swatches do. Using it costs no request, has
       no round trip for the marker to flash across, and needs no agreement from
       Shopify about what a shade is called. The Shopify lookup below stays as
       the fallback for a swatch the index cannot answer for. */
    var fsVariantStock = new Map();

    /* Variant id to product id, for every variant FastSimon sends. The SSR
       grid rewrites a card's data-product-id to the chosen VARIANT id when a
       swatch is picked, so anything that keys on the card's id after that
       point (the index lookup, the pick map, FastSimon's own click reporting)
       misses unless the id is mapped back to the product first. */
    var variantToProduct = new Map();

    var NON_OPTION_VARIANT_KEYS = {
        'sellable': 1, 'barcode': 1, 'price': 1, 'compare at price': 1,
        'product-sku': 1, 'sku': 1, 'weight': 1, 'grams': 1, 'imgs': 1, 'img': 1, 'image': 1,
        'v_id': 1, 'variant_id': 1, 'id': 1, 'title': 1, 'inventory': 1, 'inventory quantity': 1, 'quantity available': 1
    };



    /* Everything that is not a known attribute is an option (Colour, Shade,
       Size, Scent). Namespaced metafield keys are not options. */
    function isOptionKey(key) {
        var k = String(key).toLowerCase();
        if (NON_OPTION_VARIANT_KEYS[k]) return false;
        if (k.indexOf('custom.') === 0) return false;
        if (k.indexOf('split shipping.') === 0) return false;
        return true;
    }

    function indexVariantStock(products) {
        if (!products) return;
        Object.keys(products).forEach(function (id) {
            var data = products[id];
            var vra = data && data.vra;
            if (!Array.isArray(vra) || !vra.length) return;

            /* Per option value: FastSimon's own sellable, the market opinion
               from the split shipping fields, and the variant ids behind it,
               kept apart because they earn different levels of trust below. */
            var byValue = new Map();
            vra.forEach(function (variant) {
                var sellable = variantSellable(variant);
                var market = variantMarketSellable(variant);
                var vid = variantId(variant);
                if (vid != null) variantToProduct.set(String(vid), String(id));
                variantAttributes(variant).forEach(function (pair) {
                    if (!Array.isArray(pair)) return;
                    /* Option values name a swatch on most products. On others
                       FastSimon labels the swatch with the custom.colour value
                       instead (Erborian's read "#feddc0", not "Porcelain"), so
                       that hex is a key for the same variant too. */
                    var isColourValue = String(pair[0]).toLowerCase() === 'custom.colour';
                    if (!isOptionKey(pair[0]) && !isColourValue) return;
                    var values = Array.isArray(pair[1]) ? pair[1] : [pair[1]];
                    values.forEach(function (value) {
                        var key = normaliseOptionValue(value);
                        if (!key) return;
                        var entry = byValue.get(key) || { sellable: null, market: null, ids: [] };
                        /* Sellable anywhere wins: one shade can span several
                           variants and is worth offering if any can be bought. */
                        if (sellable === true) entry.sellable = true;
                        else if (sellable === false && entry.sellable === null) entry.sellable = false;
                        if (market === true) entry.market = true;
                        else if (market === false && entry.market === null) entry.market = false;
                        if (vid != null) entry.ids.push(String(vid));
                        byValue.set(key, entry);
                    });
                });
            });

            if (byValue.size) fsVariantStock.set(String(id), byValue);
        });
    }

    function cardProductId(root) {
        var card = root.closest('.fs-results-product-card') || root.closest('[data-product-id]');
        var raw = (card && card.dataset && card.dataset.productId) || null;
        if (!raw) return null;
        /* After a swatch pick the SSR grid puts the variant id here. Hand back
           the product it belongs to, so the card is still recognised as the
           same product it was decorated as. */
        if (!fsVariantStock.has(String(raw)) && variantToProduct.has(String(raw))) return variantToProduct.get(String(raw));
        return String(raw);
    }

    /* The variant id the SSR grid wrote onto the card after a swatch pick,
       or null when the card still carries its product id. */
    function cardPickedVariantId(root) {
        var card = root.closest('.fs-results-product-card') || root.closest('[data-product-id]');
        var raw = (card && card.dataset && card.dataset.productId) || null;
        return raw && variantToProduct.has(String(raw)) && !fsVariantStock.has(String(raw)) ? String(raw) : null;
    }

    /* FastSimon applies fs-swatch-out-of-stock client-side AFTER hydration, so
       a correction made synchronously inside the swatch hook is simply painted
       over by their pass a moment later. The earlier version of this only
       appeared to work because it waited on a Shopify request first and landed
       after them by luck of timing.

       So the correction is re-asserted rather than applied once: every swatch
       the index says is sellable is tagged, and a MutationObserver puts it back
       whenever their code re-marks it. The counter is there because if their
       pass ever re-marked on every mutation we would ping-pong forever; 20
       rounds is far more than a settling render needs, and stopping leaves
       their marking in place rather than looping. */
    var SWATCH_SELLABLE_ATTR = 'data-sc-sellable';
    var SWATCH_WATCH_ATTR = 'data-sc-swatch-watched';
    var swatchReassertCounts = new WeakMap();
    var SWATCH_REASSERT_LIMIT = 20;

    function markSwatchSellable(swatch, name) {
        swatch.setAttribute(SWATCH_SELLABLE_ATTR, '1');
        clearSwatchStockMarker(swatch, name);
    }

    function reassertSwatchCorrections(root) {
        Array.prototype.forEach.call(
            root.querySelectorAll('.product-swatch[' + SWATCH_SELLABLE_ATTR + '="1"]'),
            function (swatch) {
                if (swatch.classList.contains('fs-swatch-out-of-stock') ||
                    swatch.getAttribute('data-disabled') === 'true' ||
                    swatch.querySelector('.ban')) {
                    clearSwatchStockMarker(swatch, swatchColourName(swatch));
                }
            }
        );
        Array.prototype.forEach.call(
            root.querySelectorAll('.product-swatch[' + SWATCH_UNSELLABLE_ATTR + '="1"]'),
            function (swatch) {
                if (!swatch.classList.contains('fs-swatch-out-of-stock') ||
                    swatch.getAttribute('data-disabled') !== 'true') {
                    markSwatchSoldOut(swatch, swatchColourName(swatch));
                }
            }
        );
    }

    function watchSwatchReapply(root) {
        if (typeof MutationObserver !== 'function') return;
        if (root.getAttribute(SWATCH_WATCH_ATTR) === '1') return;
        root.setAttribute(SWATCH_WATCH_ATTR, '1');

        var observer = new MutationObserver(function () {
            var runs = (swatchReassertCounts.get(root) || 0) + 1;
            swatchReassertCounts.set(root, runs);
            if (runs > SWATCH_REASSERT_LIMIT) {
                observer.disconnect();
                return;
            }
            /* Re-run the index pass too: a re-render can replace the swatch
               elements outright, taking our tag with them. */
            correctSwatchesFromIndex(root);
            reassertSwatchCorrections(root);
        });

        observer.observe(root, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['class', 'data-disabled']
        });
    }

    /* Returns true when every marked swatch was decided from the index, so the
       caller knows no Shopify lookup is needed. */
    function correctSwatchesFromIndex(root) {
        var id = cardProductId(root);
        var byValue = id ? fsVariantStock.get(String(id)) : null;
        if (!byValue) return false;

        var undecided = 0;
        var corrected = 0;
        var suspects = [];
        Array.prototype.forEach.call(
            root.querySelectorAll('.product-swatch'),
            function (swatch) {
                var marked = swatch.classList.contains('fs-swatch-out-of-stock');
                var ours = swatch.getAttribute(SWATCH_UNSELLABLE_ATTR) === '1';
                var name = swatchColourName(swatch);
                var key = normaliseOptionValue(name);
                var entry = key ? byValue.get(key) : undefined;
                if (!entry) { if (marked && !ours) undecided++; return; }

                /* Clearing trusts FastSimon's index: it has only ever erred
                   towards sold out, and a shade it calls sellable that the
                   market rule does not veto is safe to show. */
                if (marked && !ours && entry.sellable === true && entry.market !== false) {
                    markSwatchSellable(swatch, name);
                    corrected++;
                    return;
                }

                /* Adding is split by how much each input has earned. The split
                   shipping fields track the UK warehouse exactly (checked per
                   location against Shopify), so "cannot ship here" is marked
                   at once. FastSimon's own sellable has been wrong on in-stock
                   shades, so it is only a reason to ask Shopify, below. */
                if (!marked && entry.market === false) {
                    markSwatchSoldOut(swatch, name);
                    corrected++;
                    return;
                }
                if (!marked && entry.sellable === false) {
                    suspects.push({ swatch: swatch, name: name, entry: entry });
                    return;
                }

                if (marked && !ours && entry.sellable !== true) undecided++;
            }
        );
        if (suspects.length) confirmSwatchesWithShopify(root, suspects);
        if (corrected) watchSwatchReapply(root);
        return undecided === 0;
    }

    /* FastSimon says a shade is unsellable and drew no marker for it. Its
       word alone adds nothing; Shopify's product JSON decides. available
       false on every variant behind the shade marks it, anything else leaves
       it as FastSimon rendered it. */
    var swatchConfirmQueued = new WeakSet();

    function confirmSwatchesWithShopify(root, suspects) {
        var handle = cardProductHandle(root);
        if (!handle) return;
        /* The re-assert observer re-runs the index pass while the card is
           still off screen; one queued confirmation per card is enough. */
        if (swatchConfirmQueued.has(root)) return;
        swatchConfirmQueued.add(root);
        whenNearViewport(root, function () {
            swatchConfirmQueued.delete(root);
            confirmSwatchesNow(root, handle, suspects);
        });
    }

    function confirmSwatchesNow(root, handle, suspects) {
        if (!shopifyProductCache.has(handle)) {
            if (swatchStockChecksRun >= SWATCH_STOCK_CHECK_LIMIT) return;
            swatchStockChecksRun++;
        }
        fetchShopifyProduct(handle).then(function (shopifyProduct) {
            var variants = (shopifyProduct && shopifyProduct.variants) || [];
            if (!variants.length) return;
            var marked = 0;
            suspects.forEach(function (sus) {
                if (!sus.swatch.isConnected || sus.swatch.classList.contains('fs-swatch-out-of-stock')) return;
                var mine = variants.filter(function (v) { return sus.entry.ids.indexOf(String(v.id)) !== -1; });
                if (!mine.length) {
                    mine = variants.filter(function (v) {
                        return (v.options || []).some(function (o) { return sameOptionValue(o, sus.name); });
                    });
                }
                if (!mine.length) return;
                var anyAvailable = mine.some(function (v) { return v.available; });
                if (!anyAvailable) { markSwatchSoldOut(sus.swatch, sus.name); marked++; }
            });
            if (marked) watchSwatchReapply(root);
        }).catch(function () { /* FastSimon's rendering stands */ });
    }

    /* The grid hook fires before the swatch hook on a first render, but not on
       every re-render, so sweep any strip already carrying markers once the
       index for this page has been built. Pure DOM work, no requests. */
    function sweepSwatchesFromIndex(element) {
        if (!element || !element.querySelectorAll) return;
        Array.prototype.forEach.call(
            element.querySelectorAll('.swatches-container'),
            function (root) { correctSwatchesFromIndex(root); }
        );
    }

    var SWATCH_STOCK_GUARD = 'data-fs-swatch-stock-checked';
    var swatchStockChecksRun = 0;
    var SWATCH_STOCK_CHECK_LIMIT = 60;

    /* Walk up from the swatch strip to the card. Stops at the first ancestor
       holding exactly one product handle: more than one means we have climbed
       past the card into the grid, where the first link belongs to somebody
       else's product. */
    function cardProductHandle(el) {
        var node = el;
        for (var depth = 0; node && depth < 15; depth++, node = node.parentElement) {
            if (!node.querySelectorAll) continue;
            var handles = {};
            var found = [];
            Array.prototype.forEach.call(
                node.querySelectorAll('a[href*="/products/"]'),
                function (link) {
                    var href = link.getAttribute('href') || '';
                    var handle = href.split('/products/')[1];
                    if (!handle) return;
                    handle = handle.split('?')[0].split('#')[0].replace(/\/$/, '');
                    if (!handle || handles[handle]) return;
                    handles[handle] = true;
                    found.push(handle);
                }
            );
            if (found.length === 1) return found[0];
            if (found.length > 1) return null;
        }
        return null;
    }

    function swatchColourName(swatch) {
        var container = swatch.closest('.color-swatch-container') ||
                        swatch.closest('.fs-color-swatch-container') ||
                        swatch.parentElement;
        var label = container && container.querySelector('.fs-color-name, .color-swatch-color-name');
        var name = label && label.textContent ? label.textContent.trim() : '';
        if (name) return name;

        /* No visible name on this layout, so fall back to the dot's aria-label,
           which FastSimon suffixes with the stock state. */
        var dot = swatch.querySelector('.swatch-color');
        var aria = (dot && dot.getAttribute('aria-label')) || '';
        return aria.replace(/\s*\(out of stock\)\s*$/i, '').trim();
    }

    /* Compare shade names leniently. FastSimon renders the name into markup,
       so it can pick up a non-breaking space, doubled spacing or different
       casing on the way through without meaning a different shade. Matching
       those strictly against Shopify's option value silently fails to match,
       and a failed match leaves a false sold-out marker in place. */
    function sameOptionValue(a, b) {
        return normaliseOptionValue(a) === normaliseOptionValue(b);
    }

    function normaliseOptionValue(value) {
        return String(value == null ? '' : value)
            .replace(/\u00a0/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();
    }

    /* The other direction. FastSimon draws no marker on a shade its index
       calls sellable, but "sellable" there ignores where the shopper is: a
       shade held only in the US warehouse is buyable for nobody in the UK.
       Where the index plus the market rule says a shade cannot be bought
       here, mark it ourselves, in FastSimon's own vocabulary so their CSS
       draws the strike, plus a tag so the re-assert can tell our marker from
       theirs and put it back if hydration removes it. */
    var SWATCH_UNSELLABLE_ATTR = 'data-sc-unsellable';

    function markSwatchSoldOut(swatch, name) {
        swatch.setAttribute(SWATCH_UNSELLABLE_ATTR, '1');
        swatch.removeAttribute(SWATCH_SELLABLE_ATTR);
        swatch.classList.add('fs-swatch-out-of-stock');
        swatch.setAttribute('data-disabled', 'true');
        var dot = swatch.querySelector('.swatch-color');
        if (dot && name && !/\(out of stock\)\s*$/i.test(dot.getAttribute('aria-label') || '')) {
            dot.setAttribute('aria-label', name + ' (Out of Stock)');
        }
    }

    function clearSwatchStockMarker(swatch, name) {
        swatch.classList.remove('fs-swatch-out-of-stock');
        swatch.setAttribute('data-disabled', 'false');
        var ban = swatch.querySelector('.ban');
        if (ban) ban.remove();
        var dot = swatch.querySelector('.swatch-color');
        if (dot && name) dot.setAttribute('aria-label', name);
    }

    /* ------------------------------------------------------------------
       Adding the shade the shopper picked on the card.

       FastSimon's swatches report a colour to the hook, never a variant, so
       a card had no way to know which shade was showing and Add could only
       hand the whole choice to the quick view. The index built for stock
       does know: it maps each shade value on a product to the variant ids
       behind it. Every shade product in this catalogue carries a single
       option, so a shade names exactly one variant, which is enough to add
       it straight to the cart.

       Only a shade the shopper actually clicked counts. The one FastSimon
       happens to draw first is not a choice, and adding it silently would
       put the wrong colour in the bag.
       ------------------------------------------------------------------ */
    var SWATCH_VALUE_ATTR = 'data-sc-swatch-value';
    var SWATCH_PID_ATTR = 'data-sc-swatch-pid';

    /* Explicit picks, keyed by product id rather than held only on the card
       element. FastSimon redraws a card when a swatch is chosen (that is how
       the image and price change), and a redraw can hand back a fresh
       element with none of the attributes written onto the old one. The
       attributes stay for the link rewrite below; this map is what Add
       trusts, because it outlives the element. */
    var swatchPickByProduct = new Map();

    function chosenSwatchVariant(productElement) {
        if (!productElement || !productElement.getAttribute) return null;
        var current = cardProductId(productElement);
        if (!current) return null;

        /* Only an explicit pick turns Add into a direct add. FastSimon marks
           the first swatch selected on every card by default, so the
           selected class alone would mean "always add the first shade",
           which is the quick view's decision to make, not ours. The pick
           may be on the element or, after a redraw, only in the map; and it
           must be for the product the card now shows, since FastSimon can
           swap a card's product during a re-render. */
        var pid = productElement.getAttribute(SWATCH_PID_ATTR);
        var value = (pid && String(pid) === String(current)) ? productElement.getAttribute(SWATCH_VALUE_ATTR) : '';
        if (!value) value = swatchPickByProduct.get(String(current)) || '';
        if (!value) return null;

        var byValue = fsVariantStock.get(String(current));
        if (!byValue) return null;
        var entry = byValue.get(normaliseOptionValue(value));
        /* The variant id FastSimon wrote onto the card names the pick outright
           when the shade label does not match an option value. */
        if (!entry) {
            var pickedVid = cardPickedVariantId(productElement);
            if (pickedVid) {
                /* A variant is indexed under every value that names it (the
                   option value and, on some products, the custom.colour hex
                   the swatch is labelled with). Prefer the key that has a
                   swatch on the card, so the strike-through check below reads
                   the swatch the shopper can see. */
                var fallback = null;
                byValue.forEach(function (candidate, key) {
                    if (entry || !candidate.ids || candidate.ids.indexOf(pickedVid) === -1) return;
                    if (swatchElementFor(productElement, key)) { entry = candidate; value = key; }
                    else if (!fallback) fallback = { entry: candidate, key: key };
                });
                if (!entry && fallback) { entry = fallback.entry; value = fallback.key; }
            }
        }
        if (!entry) return null;
        /* More than one variant behind a shade means the choice is not
           finished, so it belongs in the quick view, not the cart. */
        if (!entry.ids || entry.ids.length !== 1) return null;

        /* Whether it can be bought follows what the card actually shows, not
           FastSimon's sellable flag: that flag is wrong on shades we hold in
           the UK, which is the whole reason the strike-through correction
           exists. Reading the swatch after those corrections have run means
           Add agrees with the strike the shopper is looking at. The market
           rule still overrides, because a shade held only in the US cannot
           be bought here however it is drawn. */
        var el = swatchElementFor(productElement, value);
        var struck = el
            ? el.classList.contains('fs-swatch-out-of-stock')
            : entry.sellable === false;

        return {
            id: String(entry.ids[0]),
            sellable: entry.market !== false && !struck
        };
    }

    function swatchElementFor(productElement, value) {
        var wanted = normaliseOptionValue(value);
        var found = null;
        Array.prototype.forEach.call(
            productElement.querySelectorAll('.product-swatch'),
            function (sw) {
                if (found) return;
                if (normaliseOptionValue(swatchColourName(sw)) === wanted) found = sw;
            }
        );
        return found;
    }

    function rememberSwatchChoice(swatch) {
        var card = swatch.closest && swatch.closest('.fs-results-product-card');
        if (!card) return;
        var name = swatchColourName(swatch);
        var pid = cardProductId(card);
        if (!name || !pid) return;

        card.setAttribute(SWATCH_VALUE_ATTR, name);
        card.setAttribute(SWATCH_PID_ATTR, String(pid));
        swatchPickByProduct.set(String(pid), name);

        /* Carry the shade onto the card's links as well, so opening the
           product page from here lands on the shade being looked at. */
        var chosen = chosenSwatchVariant(card);
        if (!chosen) return;
        Array.prototype.forEach.call(card.querySelectorAll('a[href*="/products/"]'), function (link) {
            try {
                var base = (window.location && window.location.origin) || 'https://www.skincupid.co.uk';
                var url = new URL(link.getAttribute('href'), base);
                url.searchParams.set('variant', chosen.id);
                link.setAttribute('href', url.pathname + url.search + url.hash);
            } catch (err) { /* leave the link as it was */ }
        });
    }

    /* Delegated on document in the capture phase. FastSimon replaces the
       swatch strip on every re-render, so a listener bound to the strip
       would need rebinding each time, and capture reads the label before
       their own handler can rebuild anything underneath it. */
    if (typeof document !== 'undefined' && document.addEventListener) {
        document.addEventListener('click', function (e) {
            var target = e.target;
            if (!target || !target.closest) return;
            var swatch = target.closest('.product-swatch');
            if (!swatch) return;
            try { rememberSwatchChoice(swatch); } catch (err) { /* never block the click */ }
        }, true);
    }

    /* Deferred to first view. A collection page can render forty cards and
       FastSimon's stock data is wrong widely enough that many of them carry a
       marker, so checking every one on load would spend requests on cards the
       shopper never scrolls to. Waiting until a card is near the viewport ties
       the cost to what is actually looked at, which also means the budget below
       stops being the thing that decides whether a card gets corrected. */
    var nearViewportObserver = null;
    var nearViewportQueue = new WeakMap();

    /* Run fn once target is within 300px of the viewport. Shared by every
       Shopify lookup a card can need (swatch confirmation, size pill
       reconciliation), so a 48-card page spends requests only on the cards
       the shopper actually reaches. A target that FastSimon replaces before
       it scrolls into view is simply dropped: the replacement card is
       decorated afresh by the hook and queues its own lookups. */
    function whenNearViewport(target, fn) {
        if (typeof IntersectionObserver !== 'function' || !target || target.nodeType !== 1) {
            fn();
            return;
        }
        if (!nearViewportObserver) {
            nearViewportObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    nearViewportObserver.unobserve(entry.target);
                    var fns = nearViewportQueue.get(entry.target) || [];
                    nearViewportQueue.delete(entry.target);
                    fns.forEach(function (f) {
                        try { f(); } catch (e) { /* one lookup failing must not stop the rest */ }
                    });
                });
            }, { rootMargin: '300px' });
        }
        var queued = nearViewportQueue.get(target);
        if (queued) { queued.push(fn); return; }
        nearViewportQueue.set(target, [fn]);
        nearViewportObserver.observe(target);
    }

    function observeSwatchStock(root) {
        whenNearViewport(root, function () { runSwatchStockCheck(root); });
    }

    function correctSwatchStockMarkers(swatchesElement) {
        if (!swatchesElement || swatchesElement.nodeType !== 1) return;

        var root = swatchesElement.classList.contains('swatches-container')
            ? swatchesElement
            : (swatchesElement.closest('.swatches-container') || swatchesElement);

        if (root.getAttribute(SWATCH_STOCK_GUARD) === '1') return;
        root.setAttribute(SWATCH_STOCK_GUARD, '1');

        /* FastSimon's own index first, on every strip: it answers for free and
           without a flash, and it is the only pass that can ADD a marker on a
           shade FastSimon left unmarked but this shopper cannot buy. Only a
           marked swatch the index cannot decide falls through to Shopify. */
        var decided = correctSwatchesFromIndex(root);
        if (decided || !root.querySelector('.product-swatch.fs-swatch-out-of-stock:not([' + SWATCH_UNSELLABLE_ATTR + '])')) return;

        observeSwatchStock(root);
    }

    function runSwatchStockCheck(root) {
        var handle = cardProductHandle(root);
        if (!handle) return;

        if (!shopifyProductCache.has(handle)) {
            if (swatchStockChecksRun >= SWATCH_STOCK_CHECK_LIMIT) return;
            swatchStockChecksRun++;
        }

        fetchShopifyProduct(handle).then(function (shopifyProduct) {
            var variants = (shopifyProduct && shopifyProduct.variants) || [];
            if (!variants.length) return;

            /* Re-query: FastSimon may have re-rendered while the request was in
               flight, in which case the nodes captured earlier are detached. */
            Array.prototype.forEach.call(
                root.querySelectorAll('.product-swatch.fs-swatch-out-of-stock'),
                function (swatch) {
                    var name = swatchColourName(swatch);
                    if (!name) return;

                    /* A swatch is one colour, which on a multi-option product
                       spans several variants. Purchasable in any of them is
                       enough for the shade itself to be worth showing. */
                    /* Shopify's product JSON has no per-location view, so it can
                       only confirm stock exists somewhere. A shade the index
                       says cannot ship here stays marked whatever Shopify says;
                       the index pass has already handled those, so only the
                       undecided ones reach here. */
                    /* A swatch labelled with a colour value has no option
                       called that, so match by the variant ids the index
                       recorded for the label first, then by option value. */
                    var pid = cardProductId(root);
                    var byValue = pid ? fsVariantStock.get(String(pid)) : null;
                    var entry = byValue ? byValue.get(normaliseOptionValue(name)) : null;
                    var ids = (entry && entry.ids) || [];
                    var purchasable = variants.some(function (variant) {
                        if (!variant || !variant.available) return false;
                        if (ids.length) return ids.indexOf(String(variant.id)) !== -1;
                        return (variant.options || []).some(function (option) {
                            return sameOptionValue(option, name);
                        });
                    });

                    if (purchasable) markSwatchSellable(swatch, name);
                }
            );
            watchSwatchReapply(root);
        }).catch(function () { /* leave FastSimon's marking as it stands */ });
    }

    /**
     * Ensure swatch arrows are at the end and functional
     */
    function fsEnsureSwatchArrowsAtEnd(swatchesElement, config = {}) {
        const INIT_ATTR = 'data-fs-swatch-arrows-end-initialized';
        if (!swatchesElement || swatchesElement.nodeType !== 1) return;

        const root = swatchesElement.classList.contains('swatches-container')
            ? swatchesElement
            : (swatchesElement.closest('.swatches-container') || swatchesElement);

        if (root.getAttribute(INIT_ATTR) === '1' && root.querySelector('.js-fs-swatch-arrows-end')) return;

        const swatchesList = root.querySelector('.product-swatches') || root;
        const swatchSelector = config.swatchSelector || '.color-swatch-container.fs-color-swatch-container';
        const swatches = Array.from(swatchesList.querySelectorAll(swatchSelector));
        if (!swatches.length) return;

        // Create arrows wrapper
        let arrowsWrap = root.querySelector('.js-fs-swatch-arrows-end');
        let prevBtn, nextBtn;

        if (!arrowsWrap) {
            arrowsWrap = document.createElement('div');
            arrowsWrap.className = 'flex gap-2 items-center js-fs-swatch-arrows-end';

            prevBtn = document.createElement('button');
            prevBtn.type = 'button';
            prevBtn.className = 'w-3 bg-none border-none js-swatch-prev transition-200 hide-arrow';
            prevBtn.setAttribute('aria-label', 'Previous swatch');
            prevBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path></svg>';

            nextBtn = document.createElement('button');
            nextBtn.type = 'button';
            nextBtn.className = 'w-3 bg-none border-none js-swatch-next transition-200';
            nextBtn.setAttribute('aria-label', 'Next swatch');
            nextBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"></path></svg>';

            arrowsWrap.appendChild(prevBtn);
            arrowsWrap.appendChild(nextBtn);
            root.appendChild(arrowsWrap);
        } else {
            prevBtn = arrowsWrap.querySelector('.js-swatch-prev');
            nextBtn = arrowsWrap.querySelector('.js-swatch-next');
        }

        const ensureSelectedClassExists = () => {
            const hasSelected = swatches.some(c => c.querySelector('.product-swatch-selected'));
            if (hasSelected) return;
            swatches[0]?.querySelector('.product-swatch')?.classList.add('product-swatch-selected');
        };

        const getSelectedIndex = () => {
            const idx = swatches.findIndex(c => c.querySelector('.product-swatch-selected'));
            return idx >= 0 ? idx : 0;
        };

        const updateArrowsByIndex = (selectedIndex) => {
            prevBtn?.classList.toggle('hide-arrow', selectedIndex <= 0);
            nextBtn?.classList.toggle('hide-arrow', selectedIndex >= swatches.length - 1);
        };

        const scrollToIndex = (index) => {
        const el = swatches[index];
        if (!el) return;

        const scroller = swatchesList;
        if (!scroller) return;

        const elLeft = el.offsetLeft;
        const elRight = elLeft + el.offsetWidth;

        const viewLeft = scroller.scrollLeft;
        const viewRight = viewLeft + scroller.clientWidth;

        if (elLeft < viewLeft || elRight > viewRight) {
            const targetLeft = elLeft - (scroller.clientWidth - el.offsetWidth) / 2;
            scroller.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: 'smooth'
            });
        }
        };

        const clickSwatchAt = (index) => {
            const container = swatches[index];
            if (!container) return;

            const clickTarget = container.querySelector('.product-swatch') ||
                              container.querySelector('.swatch-color') ||
                              container;

            if (typeof clickTarget.click === 'function') {
                clickTarget.click();
            } else {
                clickTarget.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            }
        };

        const afterFsUpdates = () => {
            let ticks = 0;
            const maxTicks = 6;

            const step = () => {
                ticks++;
                ensureSelectedClassExists();
                const idx = getSelectedIndex();
                updateArrowsByIndex(idx);
                scrollToIndex(idx);
                if (ticks < maxTicks) requestAnimationFrame(step);
            };

            requestAnimationFrame(step);
        };

        if (!prevBtn.__fsBound) {
            prevBtn.addEventListener('click', (e) => {
                e.preventDefault();
                ensureSelectedClassExists();
                const current = getSelectedIndex();
                if (current <= 0) return;
                clickSwatchAt(current - 1);
                afterFsUpdates();
            });
            prevBtn.__fsBound = true;
        }

        if (!nextBtn.__fsBound) {
            nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                ensureSelectedClassExists();
                const current = getSelectedIndex();
                if (current >= swatches.length - 1) return;
                clickSwatchAt(current + 1);
                afterFsUpdates();
            });
            nextBtn.__fsBound = true;
        }

        if (!swatchesList.__fsClickBound) {
            swatchesList.addEventListener('click', (e) => {
                if (e.target?.closest?.(swatchSelector)) afterFsUpdates();
            });
            swatchesList.__fsClickBound = true;
        }

        if (!swatchesList.__fsMO) {
            const mo = new MutationObserver(() => {
                ensureSelectedClassExists();
                updateArrowsByIndex(getSelectedIndex());
            });
            mo.observe(swatchesList, { subtree: true, attributes: true, attributeFilter: ['class'] });
            swatchesList.__fsMO = mo;
        }

        ensureSelectedClassExists();
        const initialIdx = getSelectedIndex();
        updateArrowsByIndex(initialIdx);
        scrollToIndex(initialIdx);

        if (!root.__fsResizeBound) {
            window.addEventListener('resize', () => {
                ensureSelectedClassExists();
                updateArrowsByIndex(getSelectedIndex());
            }, { passive: true });
            root.__fsResizeBound = true;
        }

        root.setAttribute(INIT_ATTR, '1');
    }

    /* ============================================================================
       HOOK REGISTRATION
       ============================================================================ */
    /* ============================================================================
       PER-PRODUCT JSON-LD SCHEMA (from FastSimon's rendered grid)
       ============================================================================
       GSC's Merchant Listings report was flagging per-product gaps on collection
       pages (missing description / brand / gtin / shippingDetails / etc.) because
       FastSimon's SSR-grid injects product cards after JS hydration without a
       complete Product schema. Our Liquid-emitted ItemList in schema.liquid
       reflects Shopify's default ordering, which may not match FastSimon's
       personalised grid.

       This hook builds an ItemList from the actual rendered FastSimon products,
       emitting per-card JSON-LD with the merchant-listings fields Google wants:
       name, image, url, brand, gtin13, offers (with shippingDetails and
       hasMerchantReturnPolicy), aggregateRating where available.

       Idempotent: re-running removes the previous script before emitting the
       new one, so pagination / filter changes always produce fresh schema.
    */
    function emitFastSimonProductSchema(products, element) {
        if (!products || !element) return;

        var SHIPPING_AND_RETURN = {
            "shippingDetails": {
                "@type": "OfferShippingDetails",
                "shippingRate": { "@type": "MonetaryAmount", "value": "3.99", "currency": "GBP" },
                "shippingDestination": { "@type": "DefinedRegion", "addressCountry": "GB" },
                "deliveryTime": {
                    "@type": "ShippingDeliveryTime",
                    "handlingTime": { "@type": "QuantitativeValue", "minValue": 0, "maxValue": 1, "unitCode": "DAY" },
                    "transitTime": { "@type": "QuantitativeValue", "minValue": 2, "maxValue": 5, "unitCode": "DAY" }
                }
            },
            "hasMerchantReturnPolicy": {
                "@type": "MerchantReturnPolicy",
                "applicableCountry": "GB",
                "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                "merchantReturnDays": 14,
                "returnMethod": "https://schema.org/ReturnByMail",
                "returnFees": "https://schema.org/ReturnFeesCustomerResponsibility"
            }
        };

        function getAttFromArray(att, namesLower) {
            if (!Array.isArray(att)) return null;
            for (var i = 0; i < att.length; i++) {
                var pair = att[i];
                if (!Array.isArray(pair) || pair.length < 2) continue;
                var key = String(pair[0] || '').toLowerCase();
                for (var j = 0; j < namesLower.length; j++) {
                    if (key === namesLower[j] || key === 'custom.' + namesLower[j]) {
                        var val = pair[1];
                        if (Array.isArray(val)) return val.length ? String(val[0]) : null;
                        if (val) return String(val);
                        return null;
                    }
                }
            }
            return null;
        }

        function buildItem(productElement, data, position) {
            var url = data.productURL || data.u;
            if (!url) return null;
            var fullUrl = /^https?:/.test(url) ? url : window.location.origin + url;

            var name = data.title || data.t;
            var image = data.imageURL || data.imageURL2;
            var price = data.price != null ? data.price : data.p;
            var currency = data.currency || 'GBP';
            var available = !isProductOutOfStock(data);
            var vendor = data.v || data.vendor || data.brand;
            var barcode = (Array.isArray(data.vra) && data.vra[0] && (data.vra[0].barcode || data.vra[0].b)) || data.barcode;
            var description = data.description || data.d || getAttFromArray(data.att, ['description']);

            var offers = {
                "@type": "Offer",
                "url": fullUrl,
                "price": String(price != null ? price : ''),
                "priceCurrency": currency,
                "itemCondition": "https://schema.org/NewCondition",
                "availability": "https://schema.org/" + (available ? "InStock" : "OutOfStock")
            };
            if (barcode) offers.gtin13 = String(barcode);
            offers.shippingDetails = SHIPPING_AND_RETURN.shippingDetails;
            offers.hasMerchantReturnPolicy = SHIPPING_AND_RETURN.hasMerchantReturnPolicy;

            var product = {
                "@type": "Product",
                "@id": fullUrl,
                "url": fullUrl,
                "name": name,
                "offers": offers
            };
            if (image) {
                product.image = /^https?:/.test(image) ? image : 'https:' + image;
            }
            if (vendor) {
                product.brand = { "@type": "Brand", "name": String(vendor) };
            }
            if (description) {
                var clean = String(description).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
                if (clean.length > 300) clean = clean.substring(0, 297) + '...';
                if (clean) product.description = clean;
            }

            return { "@type": "ListItem", "position": position, "item": product };
        }

        var items = [];
        var cards = getProductElements(element);
        var position = 1;
        for (var i = 0; i < cards.length; i++) {
            var pid = cards[i].dataset.productId;
            var d = products[pid];
            if (!d) continue;
            var item = buildItem(cards[i], d, position);
            if (item) {
                items.push(item);
                position++;
            }
        }
        if (!items.length) return;

        // Remove previous emission (pagination / filter changes re-fire the hook)
        var prev = document.querySelectorAll('script[data-fs-product-schema]');
        for (var p = 0; p < prev.length; p++) prev[p].remove();

        var script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-fs-product-schema', '1');
        script.textContent = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            "@id": window.location.href.split('#')[0].split('?')[0] + '#fs-itemlist',
            "numberOfItems": items.length,
            "itemListElement": items
        });
        document.head.appendChild(script);
    }

    function hooks() {
        window.SerpOptions.registerHook('serp-product-grid', ({ products, element }) => {
            for (const productElement of getProductElements(element)) {
                const productID = productElement.dataset.productId;
                const data = products[productID];
                if (!data) continue;

                /* One card at a time, and one card's failure stays its own.
                   Without this, a single exception while decorating a card
                   aborts the loop, every card after it loses its badges, pills
                   and quick add button, and the swatch sweep at the end never
                   runs. That reads as the whole file having stopped. */
                try {
                    decorateProductCard(productElement, data);
                } catch (err) {
                    console.error('[FS hooks] card decoration failed for product', productID, err);
                }
            }

            try {
                indexVariantStock(products);
                sweepSwatchesFromIndex(element);
            } catch (err) {
                console.error('[FS hooks] swatch sweep failed', err);
            }

            try {
                emitFastSimonProductSchema(products, element);
            } catch (err) {
                console.error('[FS hooks] product schema failed', err);
            }
        });

        function decorateProductCard(productElement, data) {
            {

                addProductCardBadge(productElement, data);
                addProductCardFeatures(productElement, data);
                addSizePills(productElement, data);
                if (isPreOrderProduct(data)) addPreOrderLine(productElement);

                /* Quick View, except on bookings and subscriptions: the modal
                   offers an add to cart that can't carry a time slot or a
                   delivery plan, and the apps' pickers only exist on the
                   product page. */
                if (!isBookingProduct(data) && !isSubscriptionProduct(data)) {
                    addQuickViewButton(productElement, data.productURL);
                    addQuickViewButtonMobile(productElement, data.productURL);
                }

                /* Existing behaviour: OOS => Notify, else => ATC + Shopify verify */
                if (isBookingProduct(data)) {
                    /* Before the stock checks: a booking always links through,
                       whatever FastSimon thinks its availability is. */
                    addBookingButton(productElement, data);
                } else if (isProductOutOfStock(data)) {
                    addNotifyMeButton(productElement, data);
                    verifyShopifyRestock(productElement, data);
                } else {
                    addAddToCartButton(productElement, data);
                    verifyShopifyStock(productElement, data);
                }
            }
        }

        window.SerpOptions.registerHook('serp-top-page', ({ element }) => {
            const fsParent = element.closest('#fs-ssr-app-content');
            if (fsParent) {
                moveElementWithinProduct(
                    fsParent,
                    '.fs-top-container-desktop .fs-num-results',
                    '.filters-horizontal-container',
                    true
                );
            }
        });

        window.SerpOptions.registerHook('serp-product-swatches', ({ colors, element }) => {
            applySwatchCustomColors(colors, element);
            correctSwatchStockMarkers(element);
            fsEnsureSwatchArrowsAtEnd(element);
        });
    }

    /* ============================================================================
       INITIALIZATION
       ============================================================================ */

    if (window.SerpOptions) {
        hooks();
    } else {
        window.addEventListener('fast-serp-ready', hooks);
    }

    // SWYM is initialised lazily — when a shopper clicks a "Notify me when back
    // in stock" button, `handleNotifyMeClick()` calls `initializeSwym()` and
    // polls for the library at that point. There used to be an eager
    // `initSwymOnReady` here that polled for SWYM on every page's
    // DOMContentLoaded just to log "Back In Stock integration ready" — but for
    // shoppers without cookie consent SWYM legitimately never loads, the poll
    // exhausted its 100 attempts and logged "[SWYM] Library not loaded after
    // 10 seconds" on every page (which surfaced as a Microsoft Clarity error
    // signal). The eager init wired up nothing functional, so removed.
(function () {
  function openCartDrawer() {
    // Optional: keep your existing cart quantity refresh behaviour
    const qtyInput = document.querySelector('[data-cart-quantity-alt]');
    qtyInput?.dispatchEvent(new Event('valueChange', { bubbles: true }));

    // Your theme's cart drawer trigger
    const cartBtn = document.querySelector('[data-cart-btn]');
    if (cartBtn) {
      cartBtn.click();
      return;
    }

    // Fallback
    document.querySelector('a[href="/cart"], a[href="/cart/"]')?.click();
  }

})();
(function () {
  function getVendor(p) {
    return String(p?.v ?? p?.vendor ?? p?.brand ?? '').trim();
  }

  function insertVendor({ element, products }) {
    const cards = [...element.querySelectorAll('.fs-upsell-cross-sell-product')];

    cards.forEach((card) => {
      const productID = card.dataset.id;
      const p = products?.[productID];
      if (!p) return;

      const vendor = getVendor(p);
      if (!vendor) return;

      // Prevent duplicates on rerender
      if (card.querySelector('.fs-vendor-line')) return;

      const vendorEl = document.createElement('div');
      vendorEl.className = 'fs-vendor-line';
      vendorEl.textContent = vendor;

      // Your actual title element
      const titleEl = card.querySelector('.fs-recommendation-product-name-wrapper');
      if (!titleEl) return;

      const parent = titleEl.parentNode;
      if (!parent) return;

      // Force vendor above title even if parent is flex/grid with ordering
      parent.style.display = 'flex';
      parent.style.flexDirection = 'column';

      vendorEl.style.order = '-1';
      titleEl.style.order = '0';

      parent.insertBefore(vendorEl, titleEl);
    });
  }

  function register() {
    window.FastRecommendationWidget.registerHook('upsell-cross-sell-products', insertVendor);
  }

  if (window.FastRecommendationWidget) register();
  else window.addEventListener('fast-upsell-cross-sell-ready', register);
})();
})();
